import { render } from "./BuyukSehirNIP.vue?vue&type=template&id=38b69633"
import script from "./BuyukSehirNIP.vue?vue&type=script&lang=js"
export * from "./BuyukSehirNIP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__